<template>
  <v-container
    fluid
  >
    Change pass
  </v-container>
</template>

<script>
export default {
  name: "neoparent-change-pass",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss"></style>
